import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";

import React from "react";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import WorkShopCardSlide from "./WorkShopCardSlide";
import {cardMatchesDeckFilter} from "../../../utils/cardFilters";
import Filter from "../helpers/Filter";

function WorkShopSlider() {

    const {user, cards, deckEditorFilter} = useTypedSelector(state => state.auth);

    return <div className={'workshopSliderContainer'}>
        <div className="library-slider">
            <Swiper
                modules={[Navigation]}
                spaceBetween={7}
                loop={false}
                threshold={10}
                touchRatio={1}
                touchStartPreventDefault={true}
                navigation={{
                    prevEl: '.swiper-button-prev-lib',
                    nextEl: '.swiper-button-next-lib',
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 5, // phones, tablets, small laptops
                    },
                    2200: {
                        slidesPerView: 7, // full HD+ desktops
                    },
                }}
            >
                {Object.keys(cards)
                    .filter(item => {
                        const cardId = cards[item].id;
                        return cardMatchesDeckFilter(cardId, cards[cardId], deckEditorFilter);
                    })
                    .map((item, index) => {


                        const cardId = cards[item].id;



                        // @ts-ignore
                        const foundItem = Object.values(user.library.cards).find(item => item.id === cardId);
                        // @ts-ignore
                        const libAmount = foundItem?.amount ?? 0;

                        let canCraftCard = (libAmount < 5);

                        if (cardId === 1042 || cardId === 1043 || cardId === 1044) {
                            canCraftCard = (libAmount < 10);
                        }

                        return <SwiperSlide key={index + '_workshop'}>

                            <WorkShopCardSlide user={user} card={cards[cardId]} amount={libAmount} canCraftCard={canCraftCard}/>

                        </SwiperSlide>;
                    })}

            </Swiper>
            <div className="swiper-button-prev swiper-button-prev-lib"></div>
            <div className="swiper-button-next swiper-button-next-lib"></div>
        </div>
        <Filter />
    </div>
}

export default WorkShopSlider;